import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listarBodegas, crearBodega, editarBodega, eliminarBodega, type EntradaBodega } from '../lib/api/bodegas';
import { qk } from './keys';

export function useBodegas() {
  return useQuery({ queryKey: qk.bodegas, queryFn: listarBodegas });
}

export function useCrearBodega() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: EntradaBodega) => crearBodega(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.bodegas });
      qc.invalidateQueries({ queryKey: qk.movimientos });
      qc.invalidateQueries({ queryKey: qk.dashboard });
    },
  });
}

export function useEditarBodega() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EntradaBodega }) => editarBodega(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.bodegas });
      qc.invalidateQueries({ queryKey: qk.movimientos });
    },
  });
}

export function useEliminarBodega() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => eliminarBodega(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.bodegas });
      qc.invalidateQueries({ queryKey: qk.inventario });
      qc.invalidateQueries({ queryKey: qk.movimientos });
      qc.invalidateQueries({ queryKey: qk.dashboard });
    },
  });
}
